// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';

myw.Semaphore = class Semaphore {
    constructor() {
        this._queue = [];
        this._locked = false;
    }

    isLocked() {
        return this._locked;
    }

    lock() {
        const p = new Promise(resolve => {
            if (!this._locked) {
                this._locked = true;
                resolve();
            } else {
                this._queue.push(resolve);
            }
        });

        return p;
    }

    unlock() {
        const resolve = this._queue.shift();
        if (resolve) {
            resolve();
        } else {
            this._locked = false;
        }
    }
};

export default myw.Semaphore;
